import { HttpClient } from '../../../api/httpClient';
import { API_URL } from '../../../api/RestAPI';
import apiHeaders from '../../../api/apiHeaders';
import { setUrlForGetRequest } from '../../../api/sharedFunctions';

const createShippingProfile = (storeId, shipping) => {
  return HttpClient.post(
    `${API_URL}/stores/${storeId}/shipping-profiles/create`,
    shipping,
    apiHeaders()
  );
};

const getShippingProfiles = (storeId, params, dependent = {}) => {
  const url = setUrlForGetRequest(`${API_URL}/stores/${storeId}/shipping-profiles`, params);
  return HttpClient.get(url, apiHeaders(dependent));
};

const getShippingProfile = (storeId, id) => {
  return HttpClient.get(
    `${API_URL}/stores/${storeId}/shipping-profiles/${id}`,
    apiHeaders()
  );
};

const updateShippingProfile = (storeId, id, shipping) => {
  return HttpClient.put(
    `${API_URL}/stores/${storeId}/shipping-profiles/${id}/update`,
    shipping,
    apiHeaders()
  );
};

const removeShippingProfile = (storeId, shipping) => {
  return HttpClient.delete(
    `${API_URL}/stores/${storeId}/shipping-profiles/${shipping.id}`,
    apiHeaders()
  );
};

const getCountries = () => {
  return HttpClient.get(
    `${API_URL}/shipping-regions/countries`,
    apiHeaders()
  );
};

const ShippingApi = {
  getShippingProfiles,
  createShippingProfile,
  getShippingProfile,
  updateShippingProfile,
  removeShippingProfile,
  getCountries
};

export { ShippingApi };